import { render, staticRenderFns } from "./infoListModul.vue?vue&type=template&id=9c394f7c&scoped=true&"
import script from "./infoListModul.vue?vue&type=script&lang=js&"
export * from "./infoListModul.vue?vue&type=script&lang=js&"
import style0 from "./infoListModul.vue?vue&type=style&index=0&id=9c394f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c394f7c",
  null
  
)

export default component.exports